import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import moment from "moment/moment";
import {getAllTripTimesFromSelectedStationByOperatorApi, insertTripAPI, putTripAPI} from "../../api/trip";

export const getAllTripTimesByOperator = createAsyncThunk('getAllTripTimesByOperator', async (payload) => {
    return (await getAllTripTimesFromSelectedStationByOperatorApi(payload)).data
})


export const postDeparture = createAsyncThunk('postDeparture', async (payload, {rejectWithValue}) => {
    try {
        const response = await insertTripAPI(payload);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
        return rejectWithValue(response.data);
    } catch (error) {
        if (error.data) {
            return rejectWithValue(error.data);
        }
        return rejectWithValue({message: "serverErrorOccurred"});
    }
})


export const updateDeparture = createAsyncThunk('updateDeparture', async (payload, {rejectWithValue}) => {
    try {
        const response = await putTripAPI(payload);
        if (response.status >= 200 && response.status < 300) {
            return response.data;
        }
        return rejectWithValue(response.data);
    } catch (error) {
        if (error.data) {
            return rejectWithValue(error.data);
        }
        return rejectWithValue("serverErrorOccurred");
    }
})

const initialState = {
    departures: [],
    foundDepartures: [],
    tripTimes: [],
    departure: null,
    loadingDepartures: false
}

export const departureSlice = createSlice({
    name: 'departures',
    initialState,
    reducers: {},
    extraReducers: {
        [getAllTripTimesByOperator.pending]: (state) => {
            state.loadingTrips = true;
        },
        [getAllTripTimesByOperator.fulfilled]: (state, {payload}) => {
            state.tripTimes = payload.sort((a, b) => moment(a, 'HH:mm:ss').diff(moment(b, 'HH:mm:ss')));
            state.loadingTrips = false;
        },
        [getAllTripTimesByOperator.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [updateDeparture.pending]: (state) => {
            state.loadingTrips = true;
        },
        [updateDeparture.fulfilled]: (state) => {
            state.loadingTrips = false;
        },
        [updateDeparture.rejected]: (state) => {
            state.loadingTrips = false;
        },
        [postDeparture.pending]: (state) => {
            state.loadingTrips = true;
        },
        [postDeparture.fulfilled]: (state) => {
            state.loadingTrips = false;
        },
        [postDeparture.rejected]: (state) => {
            state.loadingTrips = false;
        }
    }
});

export const departureReducer = departureSlice.reducer
